<div class="thp-form-container" *ngIf="initialInterviewQuestions">
  <input id="talent-person-id" type="hidden" [value]="talent.personId">
  <input id="order-id" type="hidden" [value]="orderId">
  <div id="iiq-questions-progress-bar" class="progress-bar">
    <mat-progress-bar mode="determinate" [value]="getCompletionPercentage()"></mat-progress-bar>
    <p id="question-loaded-progress-bar-description" class="progress-bar-description" *ngIf="!questionsLoading">
      {{'talent-happy-path.initial-interview-questions.progress-bar-text' |
      translate:{ currentQuestionNumber: this.currentQuestionIndex + 1, totalQuestions: initialInterviewQuestions.length } }}
    </p>
    <p id="question-loading-progress-bar-description" class="progress-bar-description" *ngIf="questionsLoading">
      {{'talent-happy-path.initial-interview-questions.progress-bar-text-loading' | translate:{ currentQuestionNumber: this.currentQuestionIndex + 1 } }}
      <mat-spinner style="display:inline-block" [diameter]="15"></mat-spinner>
      {{'talent-happy-path.initial-interview-questions.progress-bar-text-loading-end' | translate}}
    </p>
  </div>
  <div class="thp-form">
    <h1 class="thp-header">
      {{ "talent-happy-path.initial-interview-questions.initial-interview-question" | translate }}
    </h1>
    <form [formGroup]="questionForm">
      <div class="field-group">
        <label id="iiq-question-text" class="field-label custom-question-label">
          {{initialInterviewQuestions[currentQuestionIndex].question}}
        </label>
        <p id="iiq-ai-question-label" *ngIf="initialInterviewQuestions[currentQuestionIndex].initialInterviewQuestionType == InitialInterviewQuestionType.CUSTOM_QUESTION && !initialInterviewQuestions[currentQuestionIndex].isStandardQuestion" class="custom-question-label-subtext">
          {{"talent-happy-path.initial-interview-questions.this-question-was-ai-generated" | translate}}
        </p>
        <textarea
          *ngIf="initialInterviewQuestions[currentQuestionIndex].typeId == QuestionType.LONG_TEXT"
          #questionInput
          id="iiq-question-textarea"
          class="custom-question-input initial-interview-question"
          formControlName="answer">
          {{initialInterviewQuestions[currentQuestionIndex].answer}}
        </textarea>
        <mat-radio-group id="iiq-radio-buttons" class="initial-interview-question"
                         *ngIf="initialInterviewQuestions[currentQuestionIndex].typeId == QuestionType.YES_NO" formControlName="answer">
          <mat-radio-button id="iiq-radio-yes" value="Yes" #questionRadioYes>{{ "talent-happy-path.radio.yes" | translate }}</mat-radio-button>
          <mat-radio-button id="iiq-radio-no" value="No"  #questionRadioNo>{{ "talent-happy-path.radio.no" | translate }}</mat-radio-button>
        </mat-radio-group>
        <mat-chip-listbox id="iiq-chips" class="initial-interview-question"
                          *ngIf="initialInterviewQuestions[currentQuestionIndex].typeId == QuestionType.MULTIPLE_CHOICE"
                          formControlName="answer">
          <mat-chip-option selectable *ngFor="let option of initialInterviewQuestions[currentQuestionIndex].optionChoiceList">
            {{option.description}}
          </mat-chip-option>
        </mat-chip-listbox>
      </div>
    </form>
  </div>
  <div  [ngClass]="!showBackButton ? 'button-container' : 'button-container double-button-container'">
    <button id="iiq-questions-back-button"
              *ngIf="showBackButton" mat-button
              class="double-custom-button back-button"
              (click)="previousQuestion()">
      <mat-icon>arrow_back</mat-icon>{{ "talent-happy-path.buttons.back" |translate }}
    </button>
    <button id="iiq-questions-next-button"
              *ngIf="!showSubmitButton" mat-button
            [ngClass]="!showBackButton ? 'custom-button single-custom-button' : 'custom-button double-custom-button next-button'"
            (click)="nextQuestion()">
      <mat-icon>arrow_forward</mat-icon>{{ "talent-happy-path.buttons.next" |translate }}
    </button>
    <button id="iiq-questions-submit-button"
              *ngIf="showSubmitButton" mat-button
            [ngClass]="!showBackButton ? 'custom-button single-custom-button' : 'custom-button double-custom-button'"
            (click)="submitAnswers()">
      {{ "talent-happy-path.buttons.submit" |translate }}
    </button>
  </div>
  <button id="iiq-questions-do-later-button" mat-button class="button-container later-button" (click)="doThisLater()">
    {{ "talent-happy-path.buttons.do-later" |translate }}
  </button>
</div>
